// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/chevron-left.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/chevron-right.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commonDatePicker{
    background: #FFFFFF;
    border: 1px solid #E7E7E8;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.12);
    border-radius: 24px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 14px;

    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
}

.commonDatePicker_head{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 4px;
}

.commonDatePicker_today{

}
                       
.commonDatePicker_dropMonth{

}
                       
.commonDatePicker_arrows{
    display: flex;
    gap: 4px;
}

.commonDatePicker_arrow{
    width: 24px;
    height: 24px;

    background: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;

    background-repeat: no-repeat;
    background-size: cover;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    font-size: 0;
}

.commonDatePicker_arrow_left{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
                               
.commonDatePicker_arrow_right{

}          
        
.commonDatePicker_week{
    display: flex;
}

.commonDatePicker_cell{
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.commonDatePicker_cell--selectedStart{
    background-color: #0000;
    background-image: radial-gradient(#FFA825 0%, #FFA825 69%, #0000 72%), linear-gradient(90deg, #0000 49%, #FFA82577 51%);
}

.commonDatePicker_cell--selectedEnd{
    background-color: #0000;
    background-image: radial-gradient(#FFA825 0%, #FFA825 69%, #0000 72%), linear-gradient(-90deg, #0000 49%, #FFA82577 51%);
}

.commonDatePicker_cell--range{
    background-color: #FFA82555;
}
 
.commonDatePicker_cell_week{
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    color: #BABABA;
}

.commonDatePicker_month{
    display: flex;
    flex-wrap: wrap;
    width: calc(32px * 7);
    gap: 6px 0px;
}

.commonDatePicker_cell_month{

}

.commonDatePicker_buttons{
    display: flex;
    gap: 8px;
}

.commonDatePicker_button{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;

    background-color: #EBEDF0;
    border-radius: 30px;
    width: 100%;
}

.commonDatePicker_button_cancel{
    color: #313131;
}

.commonDatePicker_button_apply{
    background-color: #FFA825;
    color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/components/datePicker/DatePicker.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,4CAA4C;IAC5C,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;;IAET,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,4BAA4B;IAC5B,sBAAsB;IACtB,yDAAsD;IACtD,YAAY;AAChB;;AAEA;IACI,yDAAuD;AAC3D;;AAEA;;AAEA;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,uHAAuH;AAC3H;;AAEA;IACI,uBAAuB;IACvB,wHAAwH;AAC5H;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,YAAY;AAChB;;AAEA;;AAEA;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;;IAEZ,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf","sourcesContent":[".commonDatePicker{\n    background: #FFFFFF;\n    border: 1px solid #E7E7E8;\n    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.12);\n    border-radius: 24px;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 14px;\n}\n\n.commonDatePicker_head{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0px 4px;\n}\n\n.commonDatePicker_today{\n\n}\n                       \n.commonDatePicker_dropMonth{\n\n}\n                       \n.commonDatePicker_arrows{\n    display: flex;\n    gap: 4px;\n}\n\n.commonDatePicker_arrow{\n    width: 24px;\n    height: 24px;\n\n    background: #FFFFFF;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-image: url('../../assets/chevron-left.svg');\n    font-size: 0;\n}\n\n.commonDatePicker_arrow_left{\n    background-image: url('../../assets/chevron-right.svg');\n}\n                               \n.commonDatePicker_arrow_right{\n\n}          \n        \n.commonDatePicker_week{\n    display: flex;\n}\n\n.commonDatePicker_cell{\n    width: 32px;\n    height: 32px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.commonDatePicker_cell--selectedStart{\n    background-color: #0000;\n    background-image: radial-gradient(#FFA825 0%, #FFA825 69%, #0000 72%), linear-gradient(90deg, #0000 49%, #FFA82577 51%);\n}\n\n.commonDatePicker_cell--selectedEnd{\n    background-color: #0000;\n    background-image: radial-gradient(#FFA825 0%, #FFA825 69%, #0000 72%), linear-gradient(-90deg, #0000 49%, #FFA82577 51%);\n}\n\n.commonDatePicker_cell--range{\n    background-color: #FFA82555;\n}\n \n.commonDatePicker_cell_week{\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 14px;\n    color: #BABABA;\n}\n\n.commonDatePicker_month{\n    display: flex;\n    flex-wrap: wrap;\n    width: calc(32px * 7);\n    gap: 6px 0px;\n}\n\n.commonDatePicker_cell_month{\n\n}\n\n.commonDatePicker_buttons{\n    display: flex;\n    gap: 8px;\n}\n\n.commonDatePicker_button{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 40px;\n\n    background-color: #EBEDF0;\n    border-radius: 30px;\n    width: 100%;\n}\n\n.commonDatePicker_button_cancel{\n    color: #313131;\n}\n\n.commonDatePicker_button_apply{\n    background-color: #FFA825;\n    color: #fff;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
